import React from 'react';
import Header from './Header';
import BottomNav from './BottomNav';
import { Toaster } from '../ui/sonner';

const Layout = ({ children, title, showBack = false, showSearch = true, hideNav = false }) => {
  return (
    <div className="min-h-screen bg-stone-50">
      <Header title={title} showBack={showBack} showSearch={showSearch} />
      <main className="max-w-lg mx-auto" style={{ 
        paddingTop: 'calc(3.5rem + env(safe-area-inset-top, 12px))',
        paddingBottom: 'calc(5rem + env(safe-area-inset-bottom, 16px))' 
      }}>
        {children}
      </main>
      {!hideNav && <BottomNav />}
      <Toaster position="top-center" richColors />
    </div>
  );
};

export default Layout;
